import { getSubscription } from 'public/Utilities/subscription';
import { viewMode } from 'wix-window-frontend';
import { applyVisibility, controllElementVisibility } from 'public/Utilities/common'

$w.onReady(async function () {
    await loadDesignFunctions();
    let props = $widget.props;

    await changeTemplate(props.template);
    await selectBadges(props);
    await toggleSubtitle(props.displaySubtitle, props.template);
});

$widget.onPropsChanged(async (oldProps, newProps) => {
    let props = $widget.props;
    await selectBadges(props);
    await changeTemplate(props.template);
    await toggleSubtitle(props.displaySubtitle, props.template);
});

async function changeTemplate(template) {
    $w('#multiStateBox1').changeState(`template${template}`);
}

async function selectBadges(props) {

    let badges = props.badge;
    let selectedBadges = JSON.parse(badges);
    let isAnyBadgesAvailable = selectedBadges.length > 0;
    if (!isAnyBadgesAvailable) return;
    //console.log("selectedBadges : ", selectedBadges);

    const isBadgeIndexAvailable = (templateArray, badgeIndex) => {
        //console.log("isBadgeIndexAvailable : ", templateArray , badgeIndex);
        const index = templateArray.findIndex((item) => item == badgeIndex);
        return index > -1
    }

    $w(`#template${props.template}Repeater`).forEachItem(($item, itemData, index) => {
        if (isBadgeIndexAvailable(selectedBadges, index + 1)) {
            //console.log("item no expanded : ", (index + 1).toString());
            $item(`#template${props.template}RepeaterItem`).expand();
        } else {
            //console.log("item no collapsed : ", (index + 1).toString());
            $item(`#template${props.template}RepeaterItem`).collapse();
        }
    })

}

async function toggleSubtitle(displaySubtitle, template) {
    if (template === '2' || template === '3') {
        let subtitleElementId = `#template${template}Subtitle`;

        if (displaySubtitle) {
            $w(subtitleElementId).expand();
        } else {
            $w(subtitleElementId).collapse();
        }
    }
}

/*
//function for check subscription
export async function checkSubscription() {
    let subscription = await getSubscription();

    if (subscription.isPremium) {
        $w('#multiStateBox1').restore();
        $w('#freeTrialBanner').delete();
    } else {
         if (viewMode == 'Site') {
            $w('#TrustBadgesContainer').delete();
        } else if (viewMode == 'Editor') {
            $w('#TrustBadgesContainer').restore();
            $w('#freeTrialBanner').restore();
            $w('#multiStateBox1').restore();
        }else if(viewMode == 'Preview'){
            $w('#TrustBadgesContainer').restore();
            $w('#multiStateBox1').restore();
        }
    }
}
*/

async function loadDesignFunctions() {
    handleInitialStates();
    await checkSubscription();
}

function handleInitialStates() {
    const props = $widget.props;
    if (viewMode === 'Editor') {
        $w('#multiStateBox1').changeState('initialTemplate');
    } else {
        $w('#multiStateBox1').changeState(`template${props.template}`);
    }
    //$w(ALERT_MULTI_STATE_ID).changeState(ALERT_EMPTY_STATE);
    $w('#multistateBox-freeTrialBanner').changeState('#state-freeTrialEmptyState');
}

async function checkSubscription() {
    const subscriptionResponse = await getSubscription();
    //console.log("subscriptionResponse: ", subscriptionResponse);
    if (subscriptionResponse) {
        handleFreeTrialBannerVisibility(subscriptionResponse);
        controlOnReadyFunctionsExecution(subscriptionResponse);
    }
}

function handleFreeTrialBannerVisibility(subscriptionResponse) {
    if (viewMode === 'Editor') {
        if (subscriptionResponse.isPremium) {
            $w('#multistateBox-freeTrialBanner').changeState('state-freeTrialEmptyState');
        } else {
            $w('#multistateBox-freeTrialBanner').changeState('state-freeTrialState');
        }
    } else if (viewMode == 'Preview') {
        $w('#multistateBox-freeTrialBanner').changeState('state-freeTrialEmptyState');
    } else {
        $w('#multistateBox-freeTrialBanner').changeState('state-freeTrialEmptyState');
    }
}

function controlOnReadyFunctionsExecution(subscriptionResponse) {
    if (viewMode == 'Editor' || viewMode == 'Preview') {
        applyVisibility('#TrustBadgesContainer', 'show');

    } else {
        if (subscriptionResponse.isPremium) {
            applyVisibility('#TrustBadgesContainer', 'show');
        } else {
            applyVisibility('#TrustBadgesContainer', 'hide');
        }
    }
}

async function handleSectionVisibility(subscription) {
    if (subscription.isPremium) {
        await controllElementVisibility('#multiStateBox1', 'hide');
    } else {
        await controllElementVisibility('#multiStateBox1', 'show');
    }
}